import {
  type QueryObserverResult,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query'

import type { AdminMe } from '@front/type/admin'
import type { CustomError } from '@front/type/api'

import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'

import { adminMeUrl } from './config'

export const useAdminMeQueryKey = 'get-admin-me'

export const useAdminMeQuery = (
  options?: Omit<UseQueryOptions<AdminMe, CustomError>, 'queryKey' | 'queryFn'>,
): QueryObserverResult<AdminMe, CustomError> =>
  useQuery<AdminMe, CustomError>({
    queryKey: [useAdminMeQueryKey],
    queryFn: () => axiosGet<AdminMe>(adminMeUrl),
    ...options,
  })
